import { render, staticRenderFns } from "./DialerDescription.vue?vue&type=template&id=16852627&"
import script from "./DialerDescription.vue?vue&type=script&lang=js&"
export * from "./DialerDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports